/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {
	CCInbox,
	MessageInfo_GetUnread
} from "@app/ir-q-app-common/types/message-api";
import * as React from "react";
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import {
	backgroundCell,
	InboxTable
} from "../InboxTable";
import {MessageStatuses} from "@app/ir-q-app-common/types/message";
import {capitalize} from "@app/ir-q-app-common/types/care-center/user";
import {COLORS} from "@res/colors";

type Props = {
	chat: CCInbox | MessageInfo_GetUnread
	onClick: () => void
	isOpen: boolean
	getUnreadMessages: () => number
}

export class StatusCell
	extends BaseComponent<Props> {

	render() {
		const chat = this.props.chat;
		const unreadMessages = this.props.getUnreadMessages();

		let backgroundColor = "transparent";
		if (unreadMessages)
			backgroundColor = "#fffaf0";
		if (this.props.isOpen)
			backgroundColor = COLORS.primary_light_blue;

		return <div className={`ll_h_c ${backgroundCell(backgroundColor)}`} onClick={() => this.props.onClick()}>
			{InboxTable.rowStyle(this.statusCallback(chat), unreadMessages > 0,
			                     chat.lastMessage?.status.status.toUpperCase() === MessageStatuses.FAILED.toUpperCase())}
		</div>
	}

	private statusCallback = (chat: CCInbox | MessageInfo_GetUnread) => {
		const lastMessage = chat.lastMessage;
		if (lastMessage?.replyId)
			return "Answered";

		return capitalize(lastMessage?.status.status || "");
	};

}
